import axios from "axios";
import type {
  ProPublicShareDto,
  ProShareDto,
  ProShareInput,
  ProSharesDto,
} from "dutyon-server/types";
import { httpClient } from "./httpClient";

export async function createProShare(
  id: string,
  input: ProShareInput,
  requestKey: string,
): Promise<ProShareDto> {
  return (
    await httpClient.post<ProShareDto>(`/pro/schedules/${encodeURIComponent(id)}/shares`, input, {
      headers: { "Idempotency-Key": requestKey },
    })
  ).data;
}
export async function getProShares(
  id: string,
  params?: { limit?: number; cursor?: string },
): Promise<ProSharesDto> {
  return (
    await httpClient.get<ProSharesDto>(`/pro/schedules/${encodeURIComponent(id)}/shares`, {
      params,
    })
  ).data;
}
export async function revokeProShare(id: string): Promise<void> {
  await httpClient.delete(`/pro/shares/${encodeURIComponent(id)}`);
}
// Public viewing never attaches owner credentials or triggers session refresh/logout.
const publicClient = axios.create({
  baseURL: httpClient.defaults.baseURL,
  timeout: 15000,
  withCredentials: false,
});
export async function getProPublicShare(
  token: string,
  signal?: AbortSignal,
): Promise<ProPublicShareDto> {
  if (!/^[A-Za-z0-9_-]{43}$/.test(token)) throw new Error("공유 링크를 확인해 주세요.");
  return (
    await publicClient.get<ProPublicShareDto>(`/pro/public/shares/${encodeURIComponent(token)}`, {
      signal,
    })
  ).data;
}

export async function getProShareLink(id: string): Promise<ProShareDto> {
  return (await httpClient.get<ProShareDto>(`/pro/shares/${encodeURIComponent(id)}`)).data;
}
